/**
 * Converts an ISO date string to a human-readable format.
 * @param {string} isoDateStr - Date string in ISO format (e.g., 2025-07-09T13:16:31.000Z)
 * @returns {string} - Human-readable date format (e.g., "July 9, 2025, 1:16 PM")
 */
export const formatToReadableDate = (isoDateStr) => {
  const date = new Date(isoDateStr);

  // Options for formatting
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
};
